import { ReactNode, useState } from "react";
import { ClubSidebar } from "@/components/ClubSidebar";
import { format } from "date-fns";
import { es } from "date-fns/locale";
import { useAuth } from "@/hooks/useAuth";
import { Menu } from "lucide-react";

interface ClubLayoutProps {
  children: ReactNode;
}

export function ClubLayout({ children }: ClubLayoutProps) {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div style={{ display: 'flex', height: '100vh', width: '100%' }}>
      {/* Sidebar - siempre visible en desktop, oculto en mobile */}
      <div style={{
        display: sidebarOpen ? 'block' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '260px',
        zIndex: 50,
        backgroundColor: 'rgba(0,0,0,0.5)'
      }} onClick={() => setSidebarOpen(false)}></div>
      
      <div style={{
        display: sidebarOpen ? 'block' : 'none',
        position: 'fixed',
        top: 0,
        left: 0,
        height: '100vh',
        width: '260px',
        zIndex: 51
      }}>
        <ClubSidebar />
      </div>

      {/* Sidebar desktop - siempre visible */}
      <div style={{ display: 'block' }}>
        <ClubSidebar />
      </div>

      {/* Contenido principal */}
      <div style={{ flex: 1, display: 'flex', flexDirection: 'column', backgroundColor: '#f8fafc', minWidth: 0 }}>
        <header style={{
          display: 'flex',
          alignItems: 'center',
          gap: '16px',
          padding: '16px 24px',
          borderBottom: '1px solid #e2e8f0',
          backgroundColor: '#ffffff',
          height: '64px'
        }}>
          <button
            data-testid="button-sidebar-toggle"
            onClick={() => setSidebarOpen(!sidebarOpen)}
            style={{
              display: 'none', // solo visible en mobile
              padding: '8px',
              color: '#64748b',
              backgroundColor: 'transparent',
              border: 'none',
              cursor: 'pointer',
              borderRadius: '6px'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#f1f5f9';
              e.currentTarget.style.color = '#0f172a';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = 'transparent';
              e.currentTarget.style.color = '#64748b';
            }}
          >
            <Menu style={{ width: '20px', height: '20px' }} />
          </button>
          
          <div style={{ flex: 1 }}></div>
          
          <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '16px',
            fontSize: '14px',
            color: '#64748b'
          }}>
            <span>{format(new Date(), "EEEE d 'de' MMMM 'de' yyyy", { locale: es })}</span>
            <span style={{ fontWeight: '500', color: '#0f172a' }}>
              {user?.clubName || user?.fullName || 'Club'}
            </span>
          </div>
        </header>
        
        <main style={{ flex: 1, overflow: 'auto', padding: '24px' }}>
          {children}
        </main>
      </div>

      {/* Mobile sidebar toggle */}
      <style>{`
        @media (min-width: 768px) {
          button[data-testid="button-sidebar-toggle"] {
            display: none !important;
          }
          div[style*="position: fixed"] {
            display: none !important;
          }
        }
        @media (max-width: 767px) {
          div[style*="display: block"]:nth-child(3) {
            display: none !important;
          }
          button[data-testid="button-sidebar-toggle"] {
            display: block !important;
          }
        }
      `}</style>
    </div>
  );
}
